import { blue, green, indigo, laiten, purple, gray, laitenGreen } from './colors'

export const getPrimary = (preset) => {
  switch (preset) {
    case 'laiten':
      return laiten
    case 'blue':
      return blue
    case 'laitenGreen':
      return laitenGreen
    case 'green':
      return green
    case 'indigo':
      return indigo
    case 'purple':
      return purple
    case 'gray':
      return purple
    default:
      console.error(
        'Invalid color preset, accepted values: "blue", "green", "indigo" or "purple"".'
      )
      return blue
  }
}
